<script>
    import TextInput from "../ui/TextInput.svelte";
    import Social from "./SocialItem.svelte";

    export let mode = "view"; // "view" or "edit"
    export let socials = {};

    const options = [{
        platform: "Instagram",
        key: "instagram",
        path: "instagram.com/"
    }, {
        platform: "Facebook",
        key: "facebook",
        path: "facebook.com/"
    }];

    function set (e) {
        const {key, value} = e.detail;
        socials[key] = value;
    }

    // function remove (key) {
    //     delete socials[key];
    //     socials = socials;
    // }
    function remove (e) {
        const {key} = e.detail;
        delete socials[key];
        socials = socials;
    }
</script>

<div class="socials">
    {#each options as option}
        <Social {mode} {...option} value={socials[option.key]} on:add={set} on:remove={remove}/>
    {/each}
</div>

<style>
    .socials {
        border-radius: 0.5rem;
        background-color: #F5F2EF;
        border: 1px solid #F5F2EF;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        gap: 1px;
    }
</style>